import { render, staticRenderFns } from "./Ingredients.vue?vue&type=template&id=9dab9bb4&scoped=true&"
import script from "./Ingredients.vue?vue&type=script&lang=js&"
export * from "./Ingredients.vue?vue&type=script&lang=js&"
import style0 from "./Ingredients.vue?vue&type=style&index=0&id=9dab9bb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dab9bb4",
  null
  
)

export default component.exports